export const WHATSAPP_QR_API_V1 = "v1";
export const WHATSAPP_QR_API_V2 = "v2";

export function normalizeWhatsappQrApiVersion(value) {
  return String(value ?? "").trim().toLowerCase() === WHATSAPP_QR_API_V2
    ? WHATSAPP_QR_API_V2
    : WHATSAPP_QR_API_V1;
}

export function isWhatsappQrApiV2(value) {
  return normalizeWhatsappQrApiVersion(value) === WHATSAPP_QR_API_V2;
}

const SHARED = {
  qr: true,
  pairing: true,
  pause: true,
  disconnect: true,
  deleteInstance: true,
  status: true,
  webhookConfig: true,
  sendText: true,
  sendMedia: true,
  sendLocation: true,
  listGroups: true,
  contactPhoto: true,
  checkNumber: true,
  // API Fácil aceita /apagar e devolve 200, mas o WhatsApp não revoga.
  deleteMessage: false,
};

const V1_ONLY = {
  buttons: true,
  lists: true,
  linkPreview: true,
};

const V2_ONLY = {
  mentions: true,
  mentionAll: true,
  poll: true,
  sticker: true,
  react: true,
  edit: true,
  forward: true,
  // Envio v2 da API Fácil não aplica citação.
  quote: false,
  markRead: true,
  typing: true,
  presence: true,
  accountProfile: true,
  groupAdmin: true,
  groupParticipants: true,
  groupLocation: true,
  calls: true,
  nativeMessageStatus: true,
};

function emptyCaps() {
  return {
    ...Object.fromEntries(Object.keys(SHARED).map((k) => [k, false])),
    ...Object.fromEntries(Object.keys(V1_ONLY).map((k) => [k, false])),
    ...Object.fromEntries(Object.keys(V2_ONLY).map((k) => [k, false])),
  };
}

export function whatsappQrCapabilities(version) {
  const v = normalizeWhatsappQrApiVersion(version);
  const caps = emptyCaps();
  Object.assign(caps, SHARED);
  if (v === WHATSAPP_QR_API_V2) Object.assign(caps, V2_ONLY);
  else Object.assign(caps, V1_ONLY);
  caps.version = v;
  caps.isV2 = v === WHATSAPP_QR_API_V2;
  return caps;
}

export function whatsappQrValidateMessageType(type, version) {
  const t = String(type || "text").toLowerCase();
  const caps = whatsappQrCapabilities(version);
  if (["text", "image", "video", "audio", "file", "location", "document"].includes(t)) return true;
  if (t === "poll") return caps.poll;
  if (t === "sticker") return caps.sticker;
  return false;
}
